const SelectPropertyConstants = {
  APPLICATIONS: 'applications',
  LEASES: 'leases',
  LISTINGS: 'listings',
  PAYMENTS: 'payments',
} as const;

const SelectPropertyDispatchConstants = {
  [SelectPropertyConstants.APPLICATIONS]: SelectPropertyConstants.APPLICATIONS,
  [SelectPropertyConstants.LEASES]: SelectPropertyConstants.LEASES,
  [SelectPropertyConstants.LISTINGS]: SelectPropertyConstants.LISTINGS,
  [SelectPropertyConstants.PAYMENTS]: SelectPropertyConstants.PAYMENTS,
} as const;

export { SelectPropertyDispatchConstants };
export default SelectPropertyConstants;
